/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Unavailable_BodyInputs */



/**
* | output |
* | --- |
* | "Your organisation uses Wundo in the chat, not in the browser. Here you can only open the practice conversations Wundo sends you in that chat or by email." |
*
* @param {Unavailable_BodyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const unavailable_body = /** @type {((inputs?: Unavailable_BodyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unavailable_BodyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je organisatie gebruikt Wundo in de chat, niet in de browser. Hier open je enkel de oefengesprekken die Wundo je in die chat of per mail stuurt.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre organisation utilise Wundo dans la discussion, pas dans le navigateur. Ici, vous pouvez seulement ouvrir les exercices que Wundo vous envoie dans cette discussion ou par e-mail.")
	return /** @type {LocalizedString} */ ("Your organisation uses Wundo in the chat, not in the browser. Here you can only open the practice conversations Wundo sends you in that chat or by email.")
});